//basic
import React, { Component } from 'react';
import {toJS} from 'mobx';
import { inject, observer } from 'mobx-react';

//style
import './BussniessHours.scss';

//api
import { api } from '../../../../functions/api';

//custom components
import CustomInput from '../../../../components/basic/input';

//material-ui
import { Grid, Paper } from '@material-ui/core'

//other libraries

@inject('internal')
@inject('translate')
@observer
export default class BussniessHours extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    
    timeout = null

    handleOnChange = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.updateData()
        }, 500)
    }

    updateData = async() => {
        let id = this.props.routerData.match.params.id
        let update_data = await api({
            method:'PATCH',
            url: `lists/shops/${id}`,
            authorization: this.props.internal.user.access_token,
            params: {
                opening_hours_mon_fri: this.week.state.value,
                opening_hours_sat_sun: this.weekend.state.value,

            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }

    render () {
        return (
            <div className={'shopDetailContainer'}>
            <div className="content">
                <Grid container spacing={16} >
                    <Grid item xs={12} sm={6}>
                        <Paper className={'paperContainer'}>
                            <CustomInput
                                ref={ref => (this.week = ref)}
                                text={this.props.translate.i18n.MODULES.SHOPS.BUSSNIESS_HOURS_WEEK}
                                value={toJS(this.props.internal.dataForTable.opening_hours_mon_fri)}
                                id={"week"}
                                className={"w-100"}
                                change={this.handleOnChange}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Paper className={'paperContainer'}>
                            <CustomInput
                                ref={ref => (this.weekend = ref)}
                                text={this.props.translate.i18n.MODULES.SHOPS.BUSSNIESS_HOURS_WEEKEND}
                                value={toJS(this.props.internal.dataForTable.opening_hours_sat_sun)}
                                id={"weekend"}
                                className={"w-100"}
                                change={this.handleOnChange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/shops/detail/bussniesHours/BussniessHours.jsx